import { makeStyles } from "@material-ui/core";

export const useStyles = makeStyles(theme => ({
	root: {
		flexGrow: 1,
		backgroundColor: '#181818',
		color: '#fff',
		height: '100vh'
	},
	// card: card,
	AppHeading: {
		fontWeight: 'bold',
		fontSize: '30px',
		padding: '10px'
	},
	titleSearchDiv: {
		display: "flex", 
		padding: "16px", 
		justifyContent: "space-between"
	},
	toggleIcons: {
		marginRight: "5px",
		fontSize: 20
	},
	searchRoot: {
		height: theme.spacing(3),
		display: "flex",
		justifyContent: "space-between",
		width: "35%",
		border: "1px solid #b4b2b2 !important",
		borderRadius: "4px !important"
	},
	iconButton: {
		color: theme.palette.action.active,
		transform: "scale(1, 1)",
		transition: theme.transitions.create(["transform", "color"], {
			duration: theme.transitions.duration.shorter,
			easing: theme.transitions.easing.easeInOut,
		}),
	},
	iconButtonHidden: {
		transform: "scale(0, 0)",
		"& > $icon": {
			opacity: 0,
		},
	},
	searchIconButton: {
		marginRight: theme.spacing(-6),
	},
	icon: {
		transition: theme.transitions.create(["opacity"], {
			duration: theme.transitions.duration.shorter,
			easing: theme.transitions.easing.easeInOut,
		}),
	},
	input: {
		width: "100%",
		fontSize: '13px'
	},
	searchContainer: {
		margin: "auto 16px",
		width: `calc(100% - ${theme.spacing(6 + 4)}px)`, // 6 button + 4 margin
	},
}));

const drawerWidth = 240;

export const useLayoutStyles = makeStyles(theme => {
  const isNewV1Theme = theme?.isNewV1Theme;

  return {
	root: {
	  display: 'flex',
	},
	appBar: {
	  zIndex: theme.zIndex.drawer + 1,
	},
	menuButton: {
	  marginRight: 20,
	},
	hide: {
	  display: 'none',
	},
	drawer: {
	  width: drawerWidth,
	  flexShrink: 0,
	  whiteSpace: 'nowrap',
	},
	drawerOpen: {
	  width: drawerWidth,
	  transition: theme.transitions.create('width', {
		easing: theme.transitions.easing.sharp,
		duration: theme.transitions.duration.enteringScreen,
	  }),
	  ...(isNewV1Theme && {
		backgroundColor: '#fff',
		padding: 12,
		borderRight: '1px solid #E0E0E0',
		boxSizing: 'border-box',
	  }),
	},
	drawerClose: {
	  transition: theme.transitions.create('width', {
		easing: theme.transitions.easing.sharp,
		duration: theme.transitions.duration.leavingScreen,
	  }),
	  overflowX: 'hidden',
	  width: theme.spacing(7) + 1,
	  [theme.breakpoints.up('sm')]: {
		width: theme.spacing(9) + 1,
	  },
	},
	toolbarSidebar: {
	  display: 'flex',
	  alignItems: 'center',
	  justifyContent: 'flex-start',
	  ...theme.mixins.toolbar,
	},
	toolbar: {
	  display: 'flex',
	  alignItems: 'center',
	  justifyContent: 'flex-start',
	  ...theme.mixins.toolbar,
	  minHeight: 'auto !important',
	},
	content: {
	  flexGrow: 1,
	  ...(isNewV1Theme
			? { padding: '16px', height: 'calc(100vh - 100px)',}
			: { padding: '0px 10px 10px 10px', paddingBottom: 0,paddingRight: 0, height: 'calc(100vh - 67px)',}),
	  backgroundColor: '#fff',
	  minHeight: '100%',
	  overflow: 'hidden',
	  position: 'relative',
	  top: '67px',
	},
	icon: {
	  padding: 10,
	},
	large: {
	  width: '35px !important',
	  height: '35px !important',
	  cursor: 'pointer',
	},
	nestedIcon: {
	  ...(isNewV1Theme
		? {
			paddingLeft: 0,
			paddingRight: 12,
		  }
		: {
			paddingLeft: 20,
		  }),
	},
	loaderContainer: {
	  display: 'flex',
	  margin: 'auto',
	  height: '100vh',
	  justifyContent: 'center',
	  alignItems: 'center',
	  width: '100vw',
	},
	fullContentBgColor: {
	  backgroundColor: '#EDEDED',
	  minHeight: '100vh',
	  height: '100%',
	},
	nestedList: {
	  ...(isNewV1Theme
		? { width: '100% !important',
			'& .Mui-selected svg *': {
			  color: '#ffffff !important',
			  fill: '#ffffff !important',
			},
			 padding: '6px 0px 6px 8px', boxSizing: 'border-box' }
		: { width: '100% !important' }),
	},
	defaultHeader: {
	  ...(isNewV1Theme
		? {
			height: '42px !important',

			'& .MuiListItemText-root > p': {
			  color: '#202426 !important',
			  fontSize: '14px !important',
			  fontWeight: 400,
			},
			'& svg': {
			  color: '#202426 !important',
			  height: '18px !important',
			  width: '18px !important',
			},
			'& svg:nth-child(1)': {
			  paddingRight: 12,
			},
			'& svg:nth-child(2)': {
			  paddingRight: 0,
			},
		  }
		: {}),
	},
	activeHeader: {
	  ...(isNewV1Theme
		? {
			background: '#E4E8FF !important',
			borderRadius: '4px',
			position: 'relative',
			height: '42px !important',
			'&::after': {
			  content: '""',
			  position: 'absolute',
			  top: 0,
			  bottom: 0,
			  right: '-12px',
			  background: '#E4E8FF !important',
			  zIndex: -1,
			  borderRadius: '5p5px 0 0 5pxx',
			  borderRight: '3px solid #3F51B5',
			},
			'& .MuiListItemText-root > p': {
			  color: '#3F51B5 !important',
			  fontSize: '14px !important',
			  fontWeight: 400,
			},
			'& svg, & svg *': {
			  color: '#3F51B5 !important',
			  fill: '#3F51B5 !important',
			  height: '18px !important',
			  width: '18px !important',
			},
			'& .MuiListItemIcon-root': {
			  '& svg, & svg *': {
				color: '#3F51B5 !important',
				fill: '#3F51B5 !important',
			  },
			},
			'& svg:nth-child(1)': {
			  paddingRight: 12,
			},
			'& svg:nth-child(2)': {
			  paddingRight: 0,
			},
		  }
		: {}),
	},
  };
});